import React from "react";
export function WrongAnswer(props) {
  return (
    <span class={props.class}>
      <img src="/wrong.png" width="17px" alt="" />
    </span>
  );
}
